<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">Order List</span>
      </div>
      <div class="card-body">
        <b-tabs content-class="mt-3">
          <b-tab title="Pending Order" active="">
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="productsDatatable"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Customer Name</th>
                    <th>Products</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <!-- <th>Status</th> -->
                    <th>Assign</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr>
                    <td colspan="8" class="text-center" v-if="AllOrders.loading">
                      <sweetalert-icon icon="loading" />
                    </td>
                  </tr> -->
                  <tr
                    v-for="(order, index) in AllOrders.data.pending"
                    :key="index"
                  >
                    <td>{{ ++index }}</td>
                    <td>
                      {{
                        new Date(
                          order.order.createdAt * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      }}
                    </td>
                    <td>
                      {{
                        order.name
                          ? order.name + " " + order.number
                          : "NA" + " " + order.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'packing' + order.order.createdAt"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse
                        v-bind:id="'packing' + order.order.createdAt"
                        class="pt-2"
                      >
                        <table class="table">
                          <thead>
                            <th>#</th>
                            <th>Name</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(buck, buckindex) in order.products
                                .product"
                              :key="buckindex"
                            >
                              <td>{{ ++buckindex }}</td>
                              <td>
                                {{ buck.name }}
                              </td>
                              <td>
                                {{ buck.qty }}
                              </td>
                              <td>{{ buck.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ order.order.orderAmount }}</td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.order.payment.type === 'COD'"
                        >{{ order.order.payment.type }}</span
                      >
                      <span class="badge badge-primary" v-else>{{
                        order.order.payment.type
                      }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-success"
                        v-if="order.order.orderId === loadingStatus"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                      <button
                        class="btn btn-success"
                        @click="
                          AssignOrder(
                            'assignpacking',
                            order.order.orderId,
                            order.venderId
                          )
                        "
                        v-else
                      >
                        Assign for Packing <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <b-tab title="Currently packing">
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="productsDatatables"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Customer Name</th>
                    <th>Products</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <!-- <th>Status</th> -->
                    <th>Assign</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr>
                    <td colspan="8" class="text-center" v-if="AllOrders.loading">
                      <sweetalert-icon icon="loading" />
                    </td>
                  </tr> -->
                  <tr
                    v-for="(order, index) in AllOrders.data.packing"
                    :key="index"
                  >
                    <td>{{ ++index }}</td>
                    <td>
                      {{
                        new Date(
                          order.order.createdAt * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      }}
                    </td>
                    <td>
                      {{
                        order.name
                          ? order.name + " " + order.number
                          : "NA" + " " + order.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'packing' + order.order.createdAt"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse
                        v-bind:id="'packing' + order.order.createdAt"
                        class="pt-2"
                      >
                        <table class="table">
                          <thead>
                            <th>#</th>
                            <th>Name</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(buck, buckindex) in order.products
                                .product"
                              :key="buckindex"
                            >
                              <td>{{ ++buckindex }}</td>
                              <td>
                                {{ buck.name }}
                              </td>
                              <td>
                                {{ buck.qty }}
                              </td>
                              <td>{{ buck.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ order.order.orderAmount }}</td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.order.payment.type === 'COD'"
                        >{{ order.order.payment.type }}</span
                      >
                      <span class="badge badge-primary" v-else>{{
                        order.order.payment.type
                      }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-success"
                        v-if="order.order.orderId === loadingStatus"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                      <button
                        class="btn btn-success"
                        @click="
                          ChanceStatus(
                            'packed',
                            order.order.orderId,
                            order.venderId
                          )
                        "
                        v-else
                      >
                        Packed <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <b-tab title="Packed">
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="productsDatatabless"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Customer Name</th>
                    <th>Products</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <!-- <th>Status</th> -->
                    <th>Assign</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr>
                    <td colspan="8" class="text-center" v-if="AllOrders.loading">
                      <sweetalert-icon icon="loading" />
                    </td>
                  </tr> -->
                  <tr
                    v-for="(order, index) in AllOrders.data.packed"
                    :key="index"
                  >
                    <td>{{ ++index }}</td>
                    <td>
                      {{
                        new Date(
                          order.order.createdAt * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      }}
                    </td>
                    <td>
                      {{
                        order.name
                          ? order.name + " " + order.number
                          : "NA" + " " + order.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'packing' + order.order.createdAt"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse
                        v-bind:id="'packing' + order.order.createdAt"
                        class="pt-2"
                      >
                        <table class="table">
                          <thead>
                            <th>#</th>
                            <th>Name</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(buck, buckindex) in order.products
                                .product"
                              :key="buckindex"
                            >
                              <td>{{ ++buckindex }}</td>
                              <td>
                                {{ buck.name }}
                              </td>
                              <td>
                                {{ buck.qty }}
                              </td>
                              <td>{{ buck.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ order.order.orderAmount }}</td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.order.payment.type === 'COD'"
                        >{{ order.order.payment.type }}</span
                      >
                      <span class="badge badge-primary" v-else>{{
                        order.order.payment.type
                      }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-success"
                        v-if="order.order.orderId === loadingStatus"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                      <!-- <button
                        class="btn btn-success"
                        @click="
                          ChanceStatus(
                            'packed',
                            order.order.orderId,
                            order.venderId
                          )
                        "
                        v-else
                      >
                        Packed <i class="fa fa-check"></i>
                      </button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <b-tab title="For Delivery">
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="productsDatatablesss"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Customer Name</th>
                    <th>Products</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <!-- <th>Status</th> -->
                    <th>Assign</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr>
                    <td colspan="8" class="text-center" v-if="AllOrders.loading">
                      <sweetalert-icon icon="loading" />
                    </td>
                  </tr> -->
                  <tr
                    v-for="(order, index) in AllOrders.data.forDelivery"
                    :key="index"
                  >
                    <td>{{ ++index }}</td>
                    <td>
                      {{
                        new Date(
                          order.order.createdAt * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      }}
                    </td>
                    <td>
                      {{
                        order.name
                          ? order.name + " " + order.number
                          : "NA" + " " + order.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'packing' + order.createdAt"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse
                        v-bind:id="'packing' + order.createdAt"
                        visible
                        class="pt-2"
                      >
                        <table class="table">
                          <thead>
                            <th>#</th>
                            <th>Name</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(buck, buckindex) in order.products
                                .product"
                              :key="buckindex"
                            >
                              <td>{{ ++buckindex }}</td>
                              <td>
                                {{ buck.name }}
                              </td>
                              <td>
                                {{ buck.qty }}
                              </td>
                              <td>{{ buck.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ order.order.orderAmount }}</td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.order.payment.type === 'COD'"
                        >{{ order.order.payment.type }}</span
                      >
                      <span class="badge badge-primary" v-else>{{
                        order.order.payment.type
                      }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-success"
                        v-if="order.order.orderId === loadingStatus"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                      <button
                        class="btn btn-success"
                        @click="
                          ChanceStatus(
                            'packed',
                            order.order.orderId,
                            order.venderId
                          )
                        "
                        v-else
                      >
                        Packed <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <b-tab title="Delivered">
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="productsDatatablessss"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Customer Name</th>
                    <th>Products</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <!-- <th>Status</th> -->
                    <th>Assign</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr>
                    <td colspan="8" class="text-center" v-if="AllOrders.loading">
                      <sweetalert-icon icon="loading" />
                    </td>
                  </tr> -->
                  <tr
                    v-for="(order, index) in AllOrders.data.delivered"
                    :key="index"
                  >
                    <td>{{ ++index }}</td>
                    <td>
                      {{
                        new Date(
                          order.order.createdAt * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      }}
                    </td>
                    <td>
                      {{
                        order.name
                          ? order.name + " " + order.number
                          : "NA" + " " + order.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'packing' + order.createdAt"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse
                        v-bind:id="'packing' + order.createdAt"
                        visible
                        class="pt-2"
                      >
                        <table class="table">
                          <thead>
                            <th>#</th>
                            <th>Name</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(buck, buckindex) in order.products
                                .product"
                              :key="buckindex"
                            >
                              <td>{{ ++buckindex }}</td>
                              <td>
                                {{ buck.name }}
                              </td>
                              <td>
                                {{ buck.qty }}
                              </td>
                              <td>{{ buck.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ order.order.orderAmount }}</td>
                    <td>
                      <span
                        class="badge badge-danger"
                        v-if="order.order.payment.type === 'COD'"
                        >{{ order.order.payment.type }}</span
                      >
                      <span class="badge badge-primary" v-else>{{
                        order.order.payment.type
                      }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-success"
                        v-if="order.order.orderId === loadingStatus"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                      <button
                        class="btn btn-success"
                        @click="
                          ChanceStatus(
                            'packed',
                            order.order.orderId,
                            order.venderId
                          )
                        "
                        v-else
                      >
                        Packed <i class="fa fa-check"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <b-modal v-model="showAction" title="Assign Order" hide-footer="">
        <div v-show="addProductloading">
          <div class="col-md-12 text-center">
            <sweetalert-icon :icon="loadingType" />
          </div>
          <div class="col-md-12 text-center">
            <h3 class="text-center">{{ loadingMessage }}</h3>
          </div>
        </div>
        <b-form v-on:submit.prevent="UpdateStatus" v-show="!addProductloading">
          <b-form-group label="Select Status:">
            <b-form-select
              v-model="vendorUserId"
              required
              class="form-control"
              :options="vendorUser"
            >
            </b-form-select>
          </b-form-group>
          <button type="submit" class="btn btn-success btn-lg pull-right">
            Assign
          </button>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { dbFs } from "@/modules/database";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      perorderlist: [],
      pendingorder: [],
      flag: 0,
      pagiperPage: 10,
      pagicurrentPage: 1,
      customers: [],
      dataTable: null,
      dataTable1: null,
      dataTable2: null,
      dataTable3: null,
      updateId: "",
      actionType: "",
      showAction: false,
      addProductloading: false,
      loadingType: "loading",
      loadingMessage: "Updating",
      vendorUser: [],
      vendorUserId: null,
      products: [],
      updateOrder: [],
      allUsers: [],
      vendors: [],
      buckets: [],
      loading: false,
      orders: [],
      loadingStatus: null,
      selectedStatus: null,
      status: [
        {
          value: null,
          text: "Select Status"
        },
        {
          value: 1,
          text: "Going for Packing"
        },
        {
          value: 2,
          text: "Out for Delivery"
        },
        {
          value: 3,
          text: "Delivered"
        }
      ],
      fields: [
        {
          key: "sr",
          label: "#",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "date",
          label: "Date & Time",
          sortDirection: "desc"
        },
        {
          key: "customername",
          label: "Customer Name",
          class: "text-center"
        },
        {
          key: "products",
          label: "Products",
          class: "text-center"
        },
        {
          key: "total",
          label: "Total",
          class: "text-center"
        },
        {
          key: "payment",
          label: "Payment",
          sortable: true,
          class: "text-center"
        },
        {
          key: "status",
          label: "Status",
          class: "text-center"
        },
        {
          key: "assign",
          label: "Assign",
          class: "text-center"
        }
      ]
    };
  },
  mounted() {
    this.setupFirebaseReading();
    this.forpendingorder(0);
    this.loadOrders;
  },
  computed: {
    ...mapActions({
      loadOrders: "getCurrentVendorOrders"
    }),
    ...mapGetters({
      user: "getUser",
      AllOrders: "getOrders"
    }),
    rows() {
      console.log(this.pendingorder.length);
      return this.pendingorder.length;
    }
  },
  methods: {
    dataTablesInit() {
      this.productsDatatable = $("#productsDatatable").DataTable({
        lengthMenu: [10, 25]
      });
    },
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind(
        "orders",
        dbFs
          .collection("order")
          .where("vendorId", "==", this.$route.params.vendorId)
          .orderBy("createdAt", "desc")
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.getCustomersData();
          this.getProductsData();
          this.getVendorsData();
          this.getBucketData();
          this.getAllUser();
          this.loading = false;
        });
    },
    getCustomersData() {
      this.loading = true;
      this.$bind("customers", dbFs.collection("customer"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCustomer(id, dataType) {
      let personalDetails = {
        name: "Not Available",
        number: "Not found",
        email: ""
      };
      for (const cusKey of Object.keys(this.customers)) {
        const customer = this.customers[cusKey];
        if (id == customer.id) {
          personalDetails = customer;
        }
      }
      if (dataType == "name") {
        return personalDetails.name + " \n " + personalDetails.number;
      }
      if (dataType == "email") {
        return personalDetails.name;
      } else {
        return personalDetails.number;
      }
    },
    getProductsData() {
      this.loading = true;
      this.$bind("products", dbFs.collection("products"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBucketData() {
      this.loading = true;
      this.$bind("buckets", dbFs.collection("bucket"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAllUser() {
      this.loading = true;
      this.vendorUser = [];
      this.vendorUser.push({
        value: null,
        text: "Select User"
      });
      dbFs
        .collection("user")
        .get()
        .then(usersnapshot => {
          usersnapshot.forEach(user => {
            if (user.data().roleId != "7SUmp092o1LKD8Z9Dcas") {
              this.vendorUser.push({
                value: user.id,
                text: user.data().name
              });
            }
          });
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          // this.vendorUser = userList;
          this.loading = false;
        });
    },
    getProduct(id, dataType) {
      let productDetails = "";
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getVendorsData() {
      this.loading = true;
      this.$bind("vendors", dbFs.collection("vendor"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVendor(id, dataType) {
      let VendorDetails = "";
      for (const cusKey of Object.keys(this.vendors)) {
        const vendor = this.vendors[cusKey];
        if (id == vendor.id) {
          VendorDetails = vendor;
        }
      }
      if (dataType == "shopname") {
        return VendorDetails.shopDetails.name;
      }
      if (dataType == "ownername") {
        return VendorDetails.personalDetails.name;
      }
      if (dataType == "address") {
        let address = `${VendorDetails.shopDetails.address.firstLine},
        ${VendorDetails.shopDetails.address.city},
        ${VendorDetails.shopDetails.address.state},
        ${VendorDetails.shopDetails.address.pincode}`;
        return address;
      }
    },
    getBucket(id, dataType) {
      let bucketData = "";
      for (const cusKey of Object.keys(this.buckets)) {
        const bucket = this.buckets[cusKey];
        if (id == bucket.id) {
          bucketData = bucket;
        }
      }
      if (dataType == "all") {
        return bucketData;
      }
      if (dataType == "total") {
        let total = 0;
        if (bucketData.product) {
          for (const buck of bucketData.product) {
            let amount = buck.price;
            total += amount;
          }
        }
        return total + 50;
      }
    },
    forpendingorder(type, current = "", asper = "") {
      this.loading = true;
      this.$bind(
        "pendingorder",
        dbFs
          .collection("order")
          .where("vendorId", "==", this.$route.params.vendorId)
      )
        .then(() => {
          let count = 0;
          let status = "";
          let newOrderList = [];
          this.pendingorder.forEach(order => {
            status = this.getLastOrderStatus(order.status);
            if (status[0].type == type) {
              switch (current) {
                case "packStatus":
                  if (order.packStatus == asper) {
                    newOrderList.push(order);
                  }
                  break;
                case "deliveryStatus":
                  if (order.deliveryStatus == asper) {
                    newOrderList.push(order);
                  }
                  break;
                default:
                  newOrderList.push(order);
                  break;
              }
            }
          });
          newOrderList.forEach(doc => {
            doc["sr"] = ++count;
          });
          this.pendingorder = newOrderList;
          this.perorderlist = newOrderList.slice(0, 10);
        })
        .catch(error => {
          console.log(error);
        });
    },
    UpdateStatus() {
      this.addProductloading = true;
      this.loadingMessage = "Assign Order";
      let id = this.updateId;
      let value = "";
      let packer = "";
      // let packStatus = false;
      // let delivery = "";
      // let deliveryStatus = false;

      let vendorId = this.updateOrder;
      if (this.actionType === "assignpacking") {
        value = "1";
        packer = this.vendorUserId;
      }
      // if (this.actionType === "delivery") {
      //   value = "2";
      //   delivery = this.vendorUserId;
      // }

      dbFs
        .collection("order")
        .doc(id)
        .collection("vendor")
        .doc(vendorId)
        .update({
          packer: packer,
          packStatus: false,
          status: [
            {
              createdAt: Math.round(+new Date() / 1000),
              type: value,
              updateBy: this.user.uid
            }
          ]
        })
        .then(() => {
          this.loadingType = "success";
          this.loadingMessage = "Assign Successful";
        })
        .catch(error => {
          this.loadingType = "error";
          this.loadingMessage = error;
        })
        .finally(() => {
          this.loadOrders;
          setTimeout(() => {
            (this.showAction = false), (this.addProductloading = false);
          }, 200);
        });
    },
    getLastOrderStatus(status) {
      let lastarr = status.slice(-1)[0];
      return [lastarr];
    },
    checkOrderStatus(status, checkstatus) {
      let currstatus = [];
      if (status.length != 1) {
        let lastarr = status.slice(-1)[0];
        currstatus = [lastarr];
      } else {
        currstatus = status;
      }
      for (let index = 0; index < currstatus.length; index++) {
        if (currstatus[index].type == checkstatus) {
          return true;
        }
      }
    },
    AssignOrder(action, id, venderId) {
      this.updateOrder = venderId;
      this.updateId = id;
      this.actionType = action;
      this.showAction = true;
    },
    getUserByID(id) {
      let name = "";
      this.vendorUser.forEach(user => {
        if (user.value == id) {
          name = user.text;
        }
      });
      return name;
    },
    getOrderByStatus(type, current = "", asper = "") {
      let status = "";
      let newOrderList = [];
      this.orders.forEach(order => {
        status = this.getLastOrderStatus(order.status);
        if (status[0].type == type) {
          switch (current) {
            case "packStatus":
              if (order.packStatus == asper) {
                newOrderList.push(order);
              }
              break;
            case "deliveryStatus":
              if (order.deliveryStatus == asper) {
                newOrderList.push(order);
              }
              break;
            default:
              newOrderList.push(order);
              break;
          }
        }
      });
      return newOrderList;
    },
    ChanceStatus(type, id, vendorId) {
      if (type === "assignpacking") {
        this.loadingStatus = id;

        dbFs
          .collection("order")
          .doc(id)
          .collection("vendor")
          .doc(vendorId)
          .update({
            packer: true,
            packStatus: false,
            status: [
              {
                createdAt: Math.round(+new Date() / 1000),
                type: "1",
                updateBy: this.user.uid
              }
            ]
          })
          .then(() => this.$root.toast("Assigned for packing"))
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.loadOrders;
            this.loadingStatus = null;
          });
      } else if (type === "packed") {
        this.loadingStatus = id;

        dbFs
          .collection("order")
          .doc(id)
          .collection("vendor")
          .doc(vendorId)
          .update({
            packer: true,
            packStatus: true,
            status: [
              {
                createdAt: Math.round(+new Date() / 1000),
                type: "1",
                updateBy: this.user.uid
              }
            ]
          })
          .then(() => this.$root.toast("Order Packed"))
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.loadOrders;
            this.loadingStatus = null;
          });
      }
    }
  },
  watch: {
    AllOrders() {
      if (this.AllOrders.data.pending) {
        setTimeout(() => {
          this.dataTablesInit();
        }, 1000);
      }
    }
  }
};
</script>

<style scoped></style>
